module.exports = __webpack_public_path__ + "img/orange_125.0b2dd04c.png";